module.exports = __webpack_public_path__ + "media/images/discover/offers/digital-voucher-app@2x-919787b838394bb6d54e6f5fa8f23de3.jpg";